"use client";

import React from "react";
import BusinessSectionBlock from "./BusinessSectionBlock";
import teleconference from "../../assets/others-new.jpeg";

export default function BusinessSectionOthers() {
  return (
    <BusinessSectionBlock
      title="Start exploring Others"
      description="This category features a variety of non–food and beverage outlets that support daily campus needs and activities. From retail and services to lifestyle and convenience shops, these tenants complement the campus ecosystem by providing practical solutions, essentials, and added value for students, staff, and visitors."
      image={teleconference}
      href="/other"
      reverse={false}
    />
  );
}